import { BoardIcon, DocumentIcon, FolderIcon, InsightIcon, StructureIcon, TimelineIcon } from "@UI";
const getIconFromType = (type, isAbstract)=>{
    if (isAbstract) return FolderIcon;
    switch(type){
        case "boards":
            return BoardIcon;
        case "documents":
            return DocumentIcon;
        case "insights":
            return InsightIcon;
        case "timelines":
            return TimelineIcon;
        case "workspaces":
            return StructureIcon;
        case "cases":
        case "groups":
        case "groups_elements":
        case "cases_documents":
        case "cases_boards":
        case "cases_insights":
        case "cases_timelines":
        case "cases_workspaces":
            return FolderIcon;
        default:
            return null;
    }
};
export { getIconFromType };
